import type { SubCompetency } from '../../types/GrowthWheelManagement'
import { isRichTextEmpty } from './RichTextView'

export function trimDesc(value: string | undefined | null): string {
  return (value ?? '').trim()
}

export function getLevelCompletionStatus(subCompetency: SubCompetency) {
  const levels = subCompetency.levelDescriptions
  const definedLevels = Object.values(levels).filter(
    desc => !isRichTextEmpty(desc),
  ).length
  return { defined: definedLevels, total: 5 }
}
